import * as React from 'react';

import { DownloadPDFControlContainer } from './DownloadPDFControlContainer';
import { FavoritesControlContainer } from './FavoritesControlContainer';
import { HideOfferControlContainer } from './HideOfferControlContainer';
import { ShowOnMapControlContainer } from './ShowOnMapControlContainer';
import { ComplainControlContainer } from './ComplainControlContainer';

// TODO добавить
// import { AddNoteControlContainer } from './AddNoteControlContainer';
// import { RequestCallContainer } from './RequestCallContainer';

export function ControlsContainer() {
  return (
    <>
      <FavoritesControlContainer />
      <HideOfferControlContainer />
      <ComplainControlContainer />
      <ShowOnMapControlContainer />
      <DownloadPDFControlContainer />
    </>
  );
}
